<template>
  <div>
    <h2 class="intro-y text-lg font-medium mt-10">Products - T-Shirts</h2>
    <div class="grid grid-cols-12 gap-6 mt-5">
      <div
        class="intro-y col-span-12 flex flex-wrap sm:flex-nowrap items-center mt-2"
      >
        <div class="mt-4 sm:mt-0">
          <form id="grid-search" class="mr-3">
            <div class="w-64 relative text-gray-700 dark:text-gray-300">
              <input
                v-model="searchQuery"
                type="text"
                class="form-control p-3 w-64 box pr-10 placeholder-theme-13"
                placeholder="Search..."
              />
              <SearchIcon
                class="w-4 h-4 absolute my-auto inset-y-0 mr-3 right-0"
              />
            </div>
          </form>
        </div>
        <div class="hidden md:block mx-auto text-gray-600">
          {{ productData.totalResults }} Total Line Items
        </div>
      </div>
    </div>
    <div class="intro-y mt-5">
      <ProductsGrid :grid-data="formattedProducts" :query="searchQuery" />
    </div>
  </div>
</template>
<script>
import { defineComponent, onMounted, computed, reactive, ref } from "vue";
import { useStore } from "@/store";
import { getLineItems } from "@/api/lineitems.js";
import ProductsGrid from "@/components/back-end/ProductsGrid";

export default defineComponent({
  components: {
    ProductsGrid
  },
  setup() {
    const store = useStore();
    let productData = reactive([]);
    let formattedProducts = reactive([]);
    let searchQuery = ref("");
    const appSettings = computed(() => store.getters["main/eventSettings"]);

    const getProductData = async eventYear => {
      if (!eventYear) {
        eventYear = appSettings.value.appYear;
      }
      let productRequest = `?eventYear=${eventYear}&type=tshirt&limit=200`;
      let allProducts = await getLineItems(productRequest);
      Object.assign(productData, allProducts);
      console.log(allProducts);
      reformattedProducts(allProducts.results);
    };

    const reformattedProducts = products => {
      let formattedProductData = [];
      products.map(p => {
        let createdAt = new Date(p.createdAt);
        let obj = {};
        obj.id = p.id;
        obj.type = p.type;
        obj.name = p.primaryContact;
        if (p.team) obj.hasTeam = true;
        obj.eventCity = p.eventCity;
        obj.eventYear = p.eventYear;
        obj.amount = p.amount;
        if (p.productDetails) {
          obj.size = p.productDetails.size;
          obj.quantity = p.productDetails.unitCount;
          obj.productName = p.productDetails.name;
        }
        obj.transactionId = p.transaction.id;
        obj.hasShipped = p.transaction.hasShipped;
        obj.created = createdAt
          .toDateString()
          .split(" ")
          .slice(1)
          .join(" ");

        formattedProductData.push(obj);
      });
      Object.assign(formattedProducts, formattedProductData);
    };

    onMounted(() => {
      getProductData();
    });

    return {
      productData,
      formattedProducts,
      searchQuery
    };
  }
});
</script>
